import React from "react";
import { motion } from "framer-motion";
import { FaFacebookF, FaTwitter, FaLinkedinIn, FaInstagram, FaPhone, FaEnvelope, FaMapMarkerAlt } from "react-icons/fa";
import { socialData } from "../../data/socialData";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-[#0F172A] w-full text-white pt-16 p-4">
      {/* CTA Section */}
      <motion.div
        className="max-w-6xl mx-auto bg-[#C9A227] text-[#0F172A] py-8 px-6 md:px-12 rounded-2xl flex flex-col md:flex-row items-center justify-between shadow-lg"
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8 }}
      >
        <div>
          <h3 className="text-3xl font-bold">Need Legal Assistance?</h3>
          <p className="mt-2 text-lg">Get in touch with our experts today.</p>
        </div>
        <motion.a href="/contact"
          className="mt-4 md:mt-0 bg-[#0F172A] text-[#C9A227] font-semibold px-6 py-3 rounded-lg hover:bg-[#1A253A] transition duration-300"
          whileHover={{ scale: 1.05 }}
        >
          Contact Us
        </motion.a>
      </motion.div>

      {/* Main Footer Content */}
      <div className="max-w-6xl mx-auto mt-10 grid grid-cols-1 md:grid-cols-3 gap-8 px-6">
        {/* 1️⃣ Law Firm Branding */}
        <motion.div
          initial={{ opacity: 0, x: -30 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8 }}
        >
          <h2 className="text-3xl font-bold text-[#C9A227]"> {socialData.name} </h2>
          <p className="text-gray-400 mt-3">
            30+ years of trusted legal services, providing justice with integrity.
          </p>
        </motion.div>

        {/* 2️⃣ Quick Links */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <h3 className="text-lg font-semibold text-[#C9A227]">Quick Links</h3>
          <ul className="mt-3 flex flex-col space-y-2">
            {[{name : "Home", link : "/"}, {name : "About", link : "/about"}, {name : "Blog", link : "/blog"},{name : "Practice", link : "/practice/null"}].map((link, index) => (
              <Link to={link.link} key={index} className="text-gray-400 hover:text-[#C9A227] transition duration-300 cursor-pointer">
                {link.name}
              </Link>
            ))}
          </ul>
        </motion.div>

        {/* 3️⃣ Contact Information */}
        <motion.div
          initial={{ opacity: 0, x: 30 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8 }}
        >
          <h3 className="text-lg font-semibold text-[#C9A227]">Contact Us</h3>
          <a
  href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(socialData.address)}`}
  target="_blank"
  rel="noopener noreferrer"
  className="flex items-center gap-1 text-gray-400 mt-3 hover:text-[#C9A227]"
>
  <FaMapMarkerAlt
    style={{ width: "25px", height: "25px" }}
    className="mr-2 text-[#C9A227]"
  />
  {socialData.address}
</a>

          <a href={`tel:${socialData.contact1}`} className=" hover:text-[#C9A227] flex text-gray-400 mt-3 items-center gap-3">
          <FaPhone className="text-[#C9A227]" size={18} />
          <span>{socialData.contact1}</span>
        </a>
        <a href={`tel:${socialData.contact2}`} className="hover:text-[#C9A227] flex text-gray-400 mt-3  items-center gap-3">
          <FaPhone className="text-[#C9A227]" size={18} />
          <span>{socialData.contact2}</span>
        </a>
        <a href={`mailto:${socialData.mail}`} className="hover:text-[#C9A227] flex text-gray-400 mt-3  items-center items-center gap-3 ">
          <FaEnvelope className="text-[#C9A227]" size={18} />
          <span>{socialData.mail}</span>
        </a>
        </motion.div>
      </div>

      {/* Social Media & Copyright */}
      <div className="mt-12 border-t border-gray-700 pt-6 flex flex-col md:flex-row items-center justify-between max-w-6xl mx-auto px-6 pb-8">
        {/* Social Media Icons */}
        <div className="flex space-x-4">
          {[FaFacebookF, FaTwitter, FaLinkedinIn, FaInstagram].map((Icon, index) => (
            <motion.a
              key={index}
              className="text-gray-400 hover:text-[#C9A227] transition duration-300 text-xl cursor-pointer"
              whileHover={{ scale: 1.1 }}
            >
              <Icon />
            </motion.a>
          ))}
        </div>

        {/* Copyright */}
        <p className="text-gray-400 text-sm mt-4 md:mt-0">
          © {new Date().getFullYear()} {socialData.name} All Rights Reserved.
        </p>
      </div>
    </footer>
  );
}
